"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var chain_1 = __importDefault(require("./chain/chain"));
var LEDGER_VALIDATOR_ADDRESS = (0, chain_1["default"])("cosmos").ledgerValidator;
// Data manually fetched from the network between heights
// 1685677 and 1685679
var data = {
    validators: [
        {
            validatorAddress: "cosmosvaloper1qwl879nx9t6kef4supyazayf7vjhennyh568ys",
            name: "Certus One",
            tokens: 2366240079223,
            votingPower: 0,
            commission: 0.125,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1qs8tnw2t8l6amtzvdemnnsq9dzk0ag0z52uzay",
            name: "Castlenode",
            tokens: 92043936577,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1q6d3d089hg59x6gcx92uumx70s5y5wadklue8s",
            name: "Ubik Capital 0%Fee",
            tokens: 473891678039,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1qaa9zej9a0ge3ugpx3pxyx602lxh3ztqgfnp42",
            name: "GAME",
            tokens: 6650119750152,
            votingPower: 0,
            commission: 0.02,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ptyzewnns2kn37ewtmv6ppsvhdnmeapvtfc9y5",
            name: "WeStaking",
            tokens: 516205416254,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1pjmngrwcsatsuyy8m3qrunaun67sr9x7z5r2qs",
            name: "Cypher Core",
            tokens: 422318772421,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1zqgheeawp7cmqk27dgyctd80rd8ryhqs6la9wc",
            name: "NO! Fee to 2025 💸 | melea.xyz",
            tokens: 3818145093031,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1z8zjv3lntpwxua0rtpvgrcwl0nm0tltgpgs6l7",
            name: "Kraken",
            tokens: 4058339434984,
            votingPower: 0,
            commission: 1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1zc0z44e42qhzltqc8qpj5qrzn836d3lftnqmgw",
            name: "Virtual Hive",
            tokens: 114032300705,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1z66j0z75a9flwnez7sa8jxx46cqu4rfhd9q82w",
            name: "debo-validator",
            tokens: 109836581370,
            votingPower: 0,
            commission: 0.2,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1rpgtz9pskr5geavkjz02caqmeep7cwwpv73axj",
            name: "Blockpower",
            tokens: 1568493633483,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1r2dthxctqzhwg299e7aaeqwfkgcc9hg8k3yd7m",
            name: " 0% Fee 🌻 Sunflower",
            tokens: 629936356911,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1rwh0cxa72d3yle3r4l8gd7vyphrmjy2kpe4x72",
            name: "pe4x72",
            tokens: 241429222763,
            votingPower: 0,
            commission: 0.2,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1rj6324uq904z5zr96zg6ew9qjyau9u6h5nflg6",
            name: "Don Cryptonium",
            tokens: 82593677494,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1rcp29q3hpd246n6qak7jluqep4v006cdsc2kkl",
            name: "in3s.com",
            tokens: 152636184646,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1yfnaup5wa3vdzx3wx9auhvzl85saqj37tqxqnu",
            name: "\bMoonlet",
            tokens: 84781248304,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1yw5s259jkcg0jzmh7sce29uk0lqqw2ump7578p",
            name: "CEX.IO ❤️🇺🇦",
            tokens: 134566485728,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1y0us8xvsvfvqkk9c6nt5cfyu5au5tww2ztve7q",
            name: "Swiss Staking",
            tokens: 1892339743010,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1yh089p0cre4nhpdqw35uzde5amg3qzexkeggdn",
            name: "High Stakes 🇨🇭",
            tokens: 79996206173,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper19rmlxkqjt950fxl849l49x0me56u9tkd5n5j62",
            name: "Post Road",
            tokens: 1006285498547,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper19yy989ka5usws6gsd8vl94y7l6ssgdwsrnscjc",
            name: "OKEx Pool",
            tokens: 703536442718,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper199mlc7fr6ll5t54w7tts7f4s0cvnqgc59nmuxf",
            name: "ShapeShift DAO",
            tokens: 1282273036847,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper19j2hd230c3hw6ds843yu8akc0xgvdvyuz9v02v",
            name: "syncnode",
            tokens: 76419572461,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper19ecn7ljwp6el2pc5lldyauwv05ufwut9mm38r5",
            name: " WhisperNode🤐",
            tokens: 241145150027,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper196ax4vc0lwpxndu9dyhvca7jhxp70rmcvrj90c",
            name: "SG-1",
            tokens: 9860979613964,
            votingPower: 0,
            commission: 0.019,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1xym2qygmr9vanpa0m7ndk3n0qxgey3ffzcyd5c",
            name: "🐡grant.fish",
            tokens: 199441594007,
            votingPower: 0,
            commission: 1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1x8rr4hcf54nz6hfckyy2n05sxss54h8wz9puzg",
            name: "cosmosgbt",
            tokens: 280033535817,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1x88j7vp2xnw3zec8ur3g4waxycyz7m0mahdv3p",
            name: "Staking Facilities",
            tokens: 1368195322562,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1x8efhljzvs52u5xa6m7crcwes7v9u0nlwdgw30",
            name: "Upbit Staking",
            tokens: 744323149689,
            votingPower: 0,
            commission: 1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1xwazl8ftks4gn00y5x3c47auquc62ssuqlj02r",
            name: "jabbey",
            tokens: 151666804947,
            votingPower: 0,
            commission: 0.04,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1x3mkgqpshvpq87d33ndsleu7gd7w47dl4ve0yy",
            name: "CrowdControl",
            tokens: 97304821100,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1xnrth5rku3z3msm9prxe3l0p2yec3d9mzxz9ka",
            name: "coinhall.org 📈🔄",
            tokens: 63532067873,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper18ruzecmqj9pv8ac0gvkgryuc7u004te9rh7w5s",
            name: "Binance Node",
            tokens: 8672624964671,
            votingPower: 0,
            commission: 0.025,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper18extdhzzl5c8tr6453e5hzaj3exrdlea90fj3y",
            name: "Smart Stake",
            tokens: 184229567352,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gp957czryfgyvxwn3tfnyy2f0t9g2p4pqeemx8",
            name: " polkachu.com",
            tokens: 415880323049,
            votingPower: 0,
            commission: 0.02,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gpx52r9h3zeul45amvcy2pysgvcwddxrgx6cnv",
            name: "StakeLab",
            tokens: 2708514389080,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1grgelyng2v6v3t8z87wu3sxgt9m5s03xfytvz7",
            name: "iqlusion",
            tokens: 1821457272838,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gxju9ky3hwxvqqagrl3dxtl49kjpxq6wlqe6m5",
            name: "🇨🇭 Vortex.live 🟢",
            tokens: 491172015448,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gf3dm2mvqhymts6ksrstlyuu2m8pw6dhfp9md2",
            name: "Blockapsis",
            tokens: 81501653332,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gf4wlkutql95j7wwsxz490s6fahlvk2s9xpwax",
            name: "Stakewolle.com | Turkey donate 🇹🇷",
            tokens: 315736909899,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gdg6qqe5a3u483unqlqsnullja23g0xvqkxtk0",
            name: "zugerselfdelegation",
            tokens: 2404554688017,
            votingPower: 0,
            commission: 1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1gjtvly9lel6zskvwtvlg5vhwpu9c9waw7sxzwx",
            name: "\tEZStaking.io",
            tokens: 462402642984,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1g48268mu5vfp4wk7dk89r0wdrakm9p5xk0q50k",
            name: "Provalidator",
            tokens: 3259051076132,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1fqzqejwkk898fcslw4z4eeqjzesynvrdfr5hte",
            name: "commercio.network",
            tokens: 155298603658,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ff0dw8kawsnxkrgj7p65kvw7jxxakyf8n583gx",
            name: "Compass",
            tokens: 96568326917,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1fsg635n5vgc7jazz9sx5725wnc3xqgr7awxaag",
            name: "cros-nest",
            tokens: 168864940907,
            votingPower: 0,
            commission: 0.02,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1fhr7e04ct0zslmkzqt9smakg3sxrdve6ulclj2",
            name: "Stakin",
            tokens: 231546845732,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1fun809ksxh87nzf88yashp9ynjz6xkscrtvzvw",
            name: "Tessellated",
            tokens: 89008522451,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper122j3zmqdl6d2g64qmjuqzj65gfejsvjp07yljn",
            name: "COS_Validator",
            tokens: 204755716213,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper12w6tynmjzq4l8zdla3v4x0jt8lt4rcz5gk7zg2",
            name: "Huobi-1",
            tokens: 70102011008,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper125umsz3fws7gepn5ccsh0sv4gre9r6a3tccz4r",
            name: "Moonstake",
            tokens: 133955467483,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper124maqmcqv8tquy764ktz7cu0gxnzfw54n3vww8",
            name: "Simply Staking",
            tokens: 596727662512,
            votingPower: 0,
            commission: 0.07,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper12lfqufkk2h3w2ycp50czme6nj3ln5tdv7nj3hx",
            name: "Fanfury | fury.fan | Stake to Win",
            tokens: 126945902275,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1tflk30mq5vgqjdly92kkhhq3raev2hnz6eete3",
            name: "Everstake",
            tokens: 7764047708973,
            votingPower: 0,
            commission: 0.06,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1thl5syhmscgnj7whdyrydw3w6vy80044hjpnxh",
            name: "RockawayX Infra",
            tokens: 306999088099,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1te8nxpc2myjfrhaty0dnzdhs5ahdh5agzuym9v",
            name: "CoinoneNode",
            tokens: 1561930615975,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1vygmh344ldv9qefss9ek7ggsnxparljlmj56q5",
            name: "PUPMØS",
            tokens: 182164051345,
            votingPower: 0,
            commission: 0.01629,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1vf44d85es37hwl9f4h9gv0e064m0lla60j9luj",
            name: "MultiChain ventures",
            tokens: 2707513998862,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1vvwtk805lxehwle9l4yudmq6mn0g32px9xtkhc",
            name: "Imperator.co",
            tokens: 2453172840371,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1v0g7guekttkdmerz5z8hjj8u8j68c6p00zqgf5",
            name: "🔥 LUNC DAO 🔥",
            tokens: 87056580504,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1v5y0tg0jllvxf5c3afml8s3awue0ymju89frut",
            name: "Zero Knowledge Validator (ZKV)",
            tokens: 9443072461637,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1v69lzl909kje64k8vae24uytpxcnpxgullz2dx",
            name: "Terra Nodes",
            tokens: 149692264531,
            votingPower: 0,
            commission: 0.04,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1v78emy9d2xe3tj974l7tmn2whca2nh9zp7s0u9",
            name: "a41",
            tokens: 131258952898,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1dqp325was50l7ut2lnx6s8xhmtwj3wrtx06gzu",
            name: "Nocturnal Labs",
            tokens: 590112513753,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1dt93l3qgmhhlp97srjyqyendrgu9nx0suxtwe8",
            name: "天照☀",
            tokens: 562540468242,
            votingPower: 0,
            commission: 0.0099,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ddle9tczl87gsvmeva3c48nenyng4n56nghmjk",
            name: "Witval",
            tokens: 280885033148,
            votingPower: 0,
            commission: 0.04,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1d0aup392g3enru7eash83sedqclaxvp7fzh6gk",
            name: "Stir",
            tokens: 84359534976,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1de7qx00pz2j6gn9k88ntxxylelkazfk3g8fgh9",
            name: "Cosmic Validator | Auto-compound",
            tokens: 75828599705,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1wqy2s6nwnxj57l0l5rdjxxr646p3al6y70435m",
            name: "Klub Staking",
            tokens: 213867104268,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1wrx0x9m9ykdhw9sg04v7uljme53wuj03aa5d4f",
            name: "Meria",
            tokens: 224905713367,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1wtv0kp6ydt03edd8kyr5arr4f3yc52vp3u2x3u",
            name: "kytzu",
            tokens: 65633141207,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1wdrypwex63geqswmcy5qynv4w3z3dyef2qmyna",
            name: "Genesis Lab",
            tokens: 98188333619,
            votingPower: 0,
            commission: 0.07,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1we6knm8qartmmh2r0qfpsz6pq0s7emv3e0meuw",
            name: "Staked",
            tokens: 1040171720731,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1wlpz5hau2ezu0gmuxav63m53d8s77az9wfzlt6",
            name: "🙏 uGaenn ⛅",
            tokens: 81235659168,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1wlagucxdxvsmvj6330864x8q3vxz4x02rmvmsu",
            name: "DSRV",
            tokens: 36475936711,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1083svrca4t350mphfv9x45wq9asrs60cdmrflj",
            name: "Notional",
            tokens: 384687081690,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper10f9wkd6vdspac05djyfwfx0uxcqxapnqhnkcg8",
            name: "Tavis Digital",
            tokens: 85723167733,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper102ruvpv2srmunfffxavttxnhezln6fnc54at8c",
            name: "Ztake.org",
            tokens: 208970486618,
            votingPower: 0,
            commission: 0.07,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: LEDGER_VALIDATOR_ADDRESS,
            name: "Ledger",
            tokens: 1465639218435,
            votingPower: 0,
            commission: 0.075,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1000ya26q2cmh399q4c5aaacd9lmmdqp90kw2jn",
            name: "Staking Fund",
            tokens: 71945739741,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper10jzj3jjd3frna0ay08sh4zu4fpy957s49jkk7m",
            name: "Onbloc Node",
            tokens: 489762576227,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper10nzaaeh2kq28t3nqsh5m8kmyv90vx7ym5mpakx",
            name: "Blockdaemon",
            tokens: 960938774996,
            votingPower: 0,
            commission: 0.06,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper10e4vsut6suau8tk9m6dnrm0slgd6npe3jx5xpv",
            name: "B-Harvest",
            tokens: 1122655348780,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper106yp7zw35wftheyyv9f9pe69t8rteumjrx52jg",
            name: "Bro_n_Bro",
            tokens: 125171888480,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper10unx6s0cdqntvrumd5hs07rgd5ytcztqh8etw6",
            name: "GATA DAO",
            tokens: 158897322681,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1symf474wnypes2d3mecllqk6l26rwz8mfjqdus",
            name: "BlockHunters 🎯",
            tokens: 390892687133,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1sxx9mszve0gaedz5ld7qdkjkfv8z992ax69k08",
            name: "e-Money.com // validator.network",
            tokens: 426455997037,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1svwt2mr4x2mx0hcmty0mxsa4rmlfau4lwx2l69",
            name: "Twinstake-Validator",
            tokens: 896161295879,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1sdz4rc95vnzh2f54sacec50vjxnmwdakfym4vh",
            name: "Chill Validation",
            tokens: 120712547209,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1sd4tl9aljmmezzudugs7zlaya7pg2895ws8tfs",
            name: "InfStones",
            tokens: 579956264171,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1s05va5d09xlq3et8mapsesqh6r5lqy7mkhwshm",
            name: "Wetez",
            tokens: 75512858317,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ssm0d433seakyak8kcf93yefhknjleeds4y3em",
            name: "IRISnet-Bianjie",
            tokens: 780311804550,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1sjllsnramtg3ewxqwwrwjxfgc4n4ef9u2lcnj0",
            name: "🐠stake.fish",
            tokens: 12465854427617,
            votingPower: 0,
            commission: 0.04,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper13ql36flc4cdjhx08hke5vpr4dyv03aafnmvtnc",
            name: "TienThuatToan Capital",
            tokens: 93377117231,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper13x77yexvf6qexfjg9czp6jhpv7vpjdwwkyhe4p",
            name: "blockscape",
            tokens: 162572828346,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper132juzk0gdmwuxvx4phug7m3ymyatxlh9734g4w",
            name: "P2P.ORG - P2P Validator",
            tokens: 3985809908630,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper130mdu9a0etmeuw52qfxk73pn0ga6gawkxsrlwf",
            name: "strangelove-ventures",
            tokens: 1337634064725,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper13sduv92y3xdhy3rpmhakrc3v7t37e7ps9l0kpv",
            name: "nylira.net",
            tokens: 336165915476,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper13nvnv6q8d3yg7tjeahjzljkqu0y27s8y9e7as9",
            name: "Latent Iron",
            tokens: 618500852628,
            votingPower: 0,
            commission: 1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper13maqgtlklmereflvg3lq3e8zrp0jsqhr8ef3kk",
            name: "ChainUp",
            tokens: 234367283757,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1jxv0u20scum4trha72c7ltfgfqef6nsch7q6cu",
            name: "Ping",
            tokens: 145704343768,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1j0vaeh27t4rll7zhmarwcuq8xtrmvqhudrgcky",
            name: "Chainflow",
            tokens: 125084103037,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1jst8q8flpn94u9uvkpae8mrkk3a5pjhxx529z2",
            name: "Node Guardians",
            tokens: 1263321100142,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1jmykcq8gylmy5tgqtel4xj4q62fdt49sl584xd",
            name: "Blocks United | blocksunited.com",
            tokens: 147360978162,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1jlr62guqwrwkdt4m3y00zh2rrsamhjf9num5xr",
            name: "StakeWithUs",
            tokens: 222182847477,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1nz3c4q40j8jyvg2hcljkwhe69872mnllf7v9xh",
            name: "Interstellar Lounge 🥃 🍸 🍹",
            tokens: 150613490975,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1nxe3gnztx8wvayj260dp6yw7jg797m8up02h7z",
            name: "Synclub",
            tokens: 81012394362,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1n229vhepft6wnkt5tjpwmxdmcnfz55jv3vp77d",
            name: "Allnodes.com ⚡️ 0% fee",
            tokens: 3663045573759,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1n3nll7yl3lcv932s2r7l6jzvkjtjk0qppp3rls",
            name: "RoundTable21 by WildSage Labs",
            tokens: 117691056176,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1n3mhyp9fvcmuu8l0q8qvjy07x0rql8q46fe2xk",
            name: "0base.vc",
            tokens: 595901675754,
            votingPower: 0,
            commission: 0.04,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1nuhls0wyf8slhmuasha5pz0u89jrf9nnugq8ak",
            name: "Golden Ratio Staking",
            tokens: 338659126520,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper15r4tc0m6hc7z8drq3dzlrtcs6rq2q9l2nvwher",
            name: "DragonStake",
            tokens: 73598583742,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper156gqf9837u7d4c4678yt3rl4ls9c5vuursrrzf",
            name: "Binance Staking",
            tokens: 3504159918432,
            votingPower: 0,
            commission: 0.025,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper15urq2dtp9qce4fyc85m6upwm9xul3049e02707",
            name: "Chorus One",
            tokens: 3571665368308,
            votingPower: 0,
            commission: 0.075,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper157v7tczs40axfgejp2m43kwuzqe0wsy0rv8puv",
            name: "POSTHUMAN ꝏ DVS",
            tokens: 716451671578,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper14qazscc80zgzx3m0m0aa30ths0p9hg8vdglqrc",
            name: "✅ CryptoCrew Validators 🏆 Winner #GameOfChains",
            tokens: 178974466615,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper140e7u946a2nqqkvcnjpjm83d0ynsqem8dnp684",
            name: "danku_zone w/ DAIC",
            tokens: 129885139553,
            votingPower: 0,
            commission: 0.04,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper140l6y2gp3gxvay6qtn70re7z2s0gn57zfd832j",
            name: " Lavender.Five Nodes 🐝",
            tokens: 316057676979,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper14kn0kk33szpwus9nh8n87fjel8djx0y070ymmj",
            name: "Forbole",
            tokens: 1597944680203,
            votingPower: 0,
            commission: 0.095,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper14k4pzckkre6uxxyd2lnhnpp8sngys9m6hl6ml7",
            name: "Polychain",
            tokens: 7212245981918,
            votingPower: 0,
            commission: 0.2,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper146kwpzhmleafmhtaxulfptyhnvwxzlvm87hwnm",
            name: "🌐 KysenPool Sky ☁️ ",
            tokens: 596392537524,
            votingPower: 0,
            commission: 0.079,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper14upntdx8lf0f49t987mj99zksxnluanvu6x4lu",
            name: "Republic Crypto",
            tokens: 88041301862,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper14l0fp639yudfl46zauvv8rkzjgd4u0zk2aseys",
            name: "ATEAM",
            tokens: 627256512496,
            votingPower: 0,
            commission: 0.099,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper14lultfckehtszvzw4ehu0apvsr77afvyju5zzy",
            name: "DokiaCapital",
            tokens: 10486040529759,
            votingPower: 0,
            commission: 0.15,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1kyfce0nvluyhgfsdzz8hwrsf5336gsc95pyy4u",
            name: "0% Fee StakeSeeker by BTCS",
            tokens: 138452226746,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1kgddca7qj96z0qcxr2c45z73cfl0c75p7f3s2e",
            name: "ChainLayer",
            tokens: 1127571873220,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1k2d9ed9vgfuk2m58a2d80q9u6qljkh4vfaqjfq",
            name: "Stakecito",
            tokens: 1049635261667,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1kn3wugetjuy4zetlq6wadchfhvu3x740ae6z6x",
            name: "Huobi",
            tokens: 184948608203,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1keltez56g3zm9w8wr8gcmmulze48g2q3usuw8c",
            name: "DeFi Wallet",
            tokens: 310340547767,
            votingPower: 0,
            commission: 0.07,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1hdrlqvyjfy5sdrseecjrutyws9khtxxaux62l7",
            name: "SmartNodes",
            tokens: 360125159893,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1hjct6q7npsspsg3dgvzk3sdf89spmlpfdn6m9d",
            name: "Figment",
            tokens: 4083033780453,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1hjadhj9nqzpye2vkmkz4thahhd0z8dh3udhq74",
            name: "Atomic Nodes",
            tokens: 778361716112,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1hmd535f69t3x262m6s9wc6jd0dmel2zevhyuhm",
            name: "Prism Protocol | Delegate for airdrop",
            tokens: 783898275979,
            votingPower: 0,
            commission: 0.075,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ha8d55747h8hsaluvz8ld88n24nfaw68rx4x92",
            name: "Lightning Capital",
            tokens: 130452980687,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1hlwku8r5h34zayle405tlesvrg5svu7ugkld20",
            name: "New Huo Staking",
            tokens: 63481886013,
            votingPower: 0,
            commission: 0.025,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1crqm3598z6qmyn2kkcl9dz7uqs4qdqnr6s8jdn",
            name: "Coinbase Cloud",
            tokens: 1451276222171,
            votingPower: 0,
            commission: 0.08,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1cgh5ksjwy2sd407lyre4l3uj2fdrqhpkzp06e6",
            name: "HashQuark",
            tokens: 310615592099,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1c4k24jzduc365kywrsvf5ujz4ya6mwympnc4en",
            name: "Coinbase Custody",
            tokens: 4371659767586,
            votingPower: 0,
            commission: 0.2,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1cc99d3xcukhedg4wcw53j7a9q68uza707vpfe7",
            name: "dForce",
            tokens: 1155265326240,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1clpqr4nrk4khgkxj78fcwwh6dl3uw4epsluffn",
            name: "Cosmostation",
            tokens: 3739171463365,
            votingPower: 0,
            commission: 0.089,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ey69r37gfxvxg62sh4r0ktpuc46pzjrm873ae8",
            name: "Sikka",
            tokens: 5494217904016,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1e859xaue4k2jzqw20cv6l7p3tmc378pc3k8g2u",
            name: "Citizen Cosmos",
            tokens: 174188251877,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1et77usu8q2hargvyusl4qzryev8x8t9wwqkxfs",
            name: "Stargaze",
            tokens: 159923131389,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ed5a27kfyu0yljmna00vtr8mgzp6rwh9zn77zz",
            name: "CROSSTECH",
            tokens: 101455365046,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1e0plfg475phrsvrlzw8gwppeva0zk5yg9fgg8c",
            name: "Easy 2 Stake",
            tokens: 158504922404,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ej2es5fjztqjcd4pwa0zyvaevtjd2y5wxxp9gd",
            name: "Frens (🤝,🤝)",
            tokens: 446786117387,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1e4vye322gkjx8n85jgcclnc7nvdvu82axnr5ll",
            name: "Binary Holdings",
            tokens: 217239911461,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1eh5mwu044gd5ntkkc2xgfg8247mgc56fz4sdg3",
            name: "BouBouNode",
            tokens: 1983332807820,
            votingPower: 0,
            commission: 0.061,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ehkfl7palwrh6w2hhr2yfrgrq8jetgucudztfe",
            name: "KalpaTech",
            tokens: 736065150140,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ec3p6a75mqwkv33zt543n6cnxqwun37rr5xlqv",
            name: "lunamint",
            tokens: 78225269490,
            votingPower: 0,
            commission: 0.15,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper16qme5yxucnaj6snx35nmwze0wyxr8wfgqxsqfw",
            name: "KIRA",
            tokens: 145560331861,
            votingPower: 0,
            commission: 0.09,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper16yupepagywvlk7uhpfchtwa0stu5f8cyhh54f2",
            name: "Stakely.io",
            tokens: 280089299516,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper16fnz0v4cnv5dpnj0p3gaft2q2kzx8z5hfrx6v5",
            name: "DACM",
            tokens: 1149513699372,
            votingPower: 0,
            commission: 0.035,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper16s96n9k9zztdgjy8q4qcxp4hn7ww98qkrka4zk",
            name: "Oni ⛩️",
            tokens: 236130975282,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper16k579jk6yt2cwmqx9dz5xvq9fug2tekvlu9qdv",
            name: "Informal Systems",
            tokens: 3228198751067,
            votingPower: 0,
            commission: 0.0811,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1m902jrk0pn4yc47zfvauqwvtq0e03nen5xgzte",
            name: "Luganodes",
            tokens: 340199198218,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ma02nlc7lchu7caufyrrqt4r6v2mpsj90y9wzd",
            name: "hashtower",
            tokens: 2170244716502,
            votingPower: 0,
            commission: 0.03,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1m73mgwn3cm2e8x9a9axa0kw8nqz8a492ms63vn",
            name: "#decentralizehk - DHK dao",
            tokens: 367141412421,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1udpsgkgyutgsglauk9vk9rs03a3skc62gup9ny",
            name: "AUDIT.one",
            tokens: 359036510260,
            votingPower: 0,
            commission: 0.07,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1usvshtypjw57edkwxq3tagme665398f0hf4wuc",
            name: "Made In Block",
            tokens: 79998199286,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ukpah0340rx7k3x2njnavwyjv6pfpvn632df9q",
            name: "IcyCRO 🧊",
            tokens: 218302143152,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1uhnsxv6m83jj3328mhrql7yax3nge5svrv6t6c",
            name: "S16 Research Ventures",
            tokens: 569606427018,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1u6ddcsjueax884l3tfrs66497c7g86skn7pa0u",
            name: "Sentinel",
            tokens: 77202681478,
            votingPower: 0,
            commission: 0.15,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1uutuwrwt3z2a5z8z3uasml3rftlpmu25aga5c6",
            name: "DelegaNetworks ∞",
            tokens: 602329319415,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ualhu3fjgg77g485gmyswkq3w0dp7gys6qzwrv",
            name: "stake.systems",
            tokens: 137777981139,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1ul2me6vukg2vac2p6ltxmqlaa7jywdgt8q76ag",
            name: "HyperblocksPro",
            tokens: 464106281837,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1awguwfrm22sh7yewkywrjujukc75a3r3tpwfyp",
            name: "Foundry USA",
            tokens: 35676506381,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1a4qlael79p76my9pml6thwhnnzsxyy4ajrvd9s",
            name: "Multiplex",
            tokens: 98408416444,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1aewyh4gtvayx6v7w592jdfylawk4rsu9tfvfgm",
            name: "Silk Nodes",
            tokens: 187413023722,
            votingPower: 0,
            commission: 0.01,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper17h2x3j7u44qkrq0sk8ul0r2qr440rwgjkfg0gh",
            name: "FreshATOMS.com",
            tokens: 336924857351,
            votingPower: 0,
            commission: 0.0299,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper17mggn4znyeyg25wd7498qxl7r2jhgue8u4qjcq",
            name: "01node",
            tokens: 470311918496,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1lzhlnpahvznwfv4jmay2tgaha5kmz5qxerarrl",
            name: "Citadel.one SuperApp",
            tokens: 2579744084301,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1lktjhnzkpkz3ehrg8psvmwhafg56kfss3q3t8m",
            name: "Umbrella ☔",
            tokens: 568112593564,
            votingPower: 0,
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1lkujuk2004p3w42tgvuvqnsdmsq8u6jqkwf9wj",
            name: "BitValidator",
            tokens: 133109114153,
            votingPower: 0,
            commission: 0.05,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1lcwxu50rvvgf9v6jy6q5mrzyhlszwtjxhtscmp",
            name: "stakezone",
            tokens: 448761484035,
            votingPower: 0,
            commission: 0,
            estimatedYearlyRewardsRate: 0
        },
        {
            validatorAddress: "cosmosvaloper1mykn77lkynl8fkwvl9tqg369u0zajzzcdhkptq",
            tokens: 90061196918,
            votingPower: 90061196918 / (0.7202 * 254624972017526),
            name: "Nodeasy.com",
            commission: 0.1,
            estimatedYearlyRewardsRate: 0
        },
    ]
};
exports["default"] = data;
//# sourceMappingURL=preloadedData.mock.js.map